<template>
	<BaseCmsPage v-slot="{page}" @load="onPageLoad">
		<div class="auth-section wrapper">
			<ClientOnly>
				<AuthSidebar v-if="!mobileBreakpoint" />
				<div class="auth-content">
					<h1 class="auth-main-title" v-html="page?.seo_h1"></h1>
					<AuthSidebar v-if="mobileBreakpoint" />
					<BaseAuthChangePasswordForm v-slot="{fields, loading, submitting, apiErrors, onSubmit, status}">
						<template v-if="apiErrors?.length">
							<div class="global-error" v-for="apiError in apiErrors" :key="apiError">{{ labels.get(apiError?.error) }}</div>
						</template>
						<div v-if="status && status?.success" class="global-success">{{ labels.get(status?.data?.label_name) }}</div>

						<div v-if="!status?.success" class="form-animated-label auth-form auth-change-password-form" :class="{'submitting': submitting, 'loading': loading}" @submit="onSubmit">
							<template v-if="!fields?.length">
								<BaseThemeUiLoading />
							</template>
							<template v-else>
								<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
									<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}]">
										<BaseFormInput />
										<BaseCmsLabel tag="label" :for="item.name" :code="item.name" />
										<span class="error" v-show="errorMessage" v-html="errorMessage" />
									</p>
								</BaseFormField>
								<button v-if="loading" class="btn-lightBlue btn-medium btn-loading"></button>
								<button v-else class="btn-lightBlue btn-medium" type="submit">
									<BaseCmsLabel code="save" />
								</button>
							</template>
						</div>
					</BaseAuthChangePasswordForm>
				</div>
				<template #fallback>
					<BaseThemeUiLoading />
				</template>
			</ClientOnly>
		</div>
	</BaseCmsPage>
</template>

<script setup>
	const labels = useLabels();
	const {mobileBreakpoint} = inject('rwd');
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>

<style lang="less" scoped>
	.auth-change-password-form{
		max-width: 600px; position: relative;
		&.loading:before{.pseudo(auto, auto); display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.3); position: absolute; top: 0; left: 0; right: 0; bottom: 55px; z-index: 11;}

		@media (max-width: @t){max-width: unset;}
	}
</style>
